import React from 'react';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Phone, Mail, Globe, Download } from 'lucide-react';

export default function VCardPage() {
  const handleDownloadVCard = () => {
    // Create VCard content
    const vCardContent = `BEGIN:VCARD
VERSION:3.0
FN:Scorz
ORG:Scorz
TEL;TYPE=CELL:+447723481388
EMAIL:support@scorz.co.uk
URL:https://scorz.co.uk
END:VCARD`;

    // Create blob and download
    const blob = new Blob([vCardContent], { type: 'text/vcard' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'Scorz.vcf';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4">
      <Card className="w-full max-w-md">
        <CardHeader className="text-center">
          <img 
            src="/scorz-logo.png"
            alt="Scorz Logo"
            className="h-24 mx-auto mb-4"
          />
          <CardTitle className="text-3xl font-bold">Scorz</CardTitle>
          <p className="text-gray-600 mt-2">Gymnastics Competition Management</p>
        </CardHeader>
        <CardContent className="space-y-6">
          {/* Contact Information */}
          <div className="space-y-4">
            <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
              <Phone className="w-5 h-5 text-[#000000]" />
              <div>
                <p className="text-sm text-gray-600">Phone</p>
                <a href="tel:+447723481388" className="font-semibold text-lg hover:text-[#000000]">
                  +44 7723 481 388
                </a>
              </div>
            </div>

            <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
              <Mail className="w-5 h-5 text-[#000000]" />
              <div>
                <p className="text-sm text-gray-600">Email</p>
                <a href="mailto:support@scorz.co.uk" className="font-semibold hover:text-[#000000]">
                  support@scorz.co.uk
                </a>
              </div>
            </div>

            <div className="flex items-center gap-3 p-3 bg-gray-50 rounded-lg">
              <Globe className="w-5 h-5 text-[#000000]" />
              <div>
                <p className="text-sm text-gray-600">Website</p>
                <a 
                  href="https://scorz.co.uk" 
                  target="_blank" 
                  rel="noopener noreferrer" 
                  className="font-semibold hover:text-[#000000]"
                >
                  scorz.co.uk
                </a>
              </div>
            </div>
          </div>

          {/* Download Button */}
          <Button 
            onClick={handleDownloadVCard}
            className="w-full bg-[#000000] hover:bg-[#333333] text-lg py-6"
          >
            <Download className="w-5 h-5 mr-2" />
            Save Contact to Phone
          </Button>

          {/* Additional Info */}
          <div className="text-center pt-4 border-t">
            <p className="text-sm text-gray-600">
              For support or enquiries during competitions,
            </p>
            <p className="text-sm text-gray-600">
              please contact Freddie on the scoring desk
            </p>
          </div>
        </CardContent>
      </Card>
    </div>
  );
}
